var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchSds } from '@api/sds';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import moment from 'moment';
const getDelegators = (name) => __awaiter(void 0, void 0, void 0, function* () {
    const incoming_delegations = [];
    const delegators = (yield fetchSds(`/delegations_api/getIncomingDelegations/${name}`));
    if (delegators) {
        delegators.forEach((element) => {
            incoming_delegations.push({
                delegation_date: moment(element.time).utc().toString(),
                delegator: element.from,
                vesting_shares: element.vests,
            });
        });
    }
    return delegators
        ? incoming_delegations
            .filter((e) => e.vesting_shares !== 0)
            .sort((a, b) => b.vesting_shares - a.vesting_shares)
        : null;
});
const getDelegatees = (name) => __awaiter(void 0, void 0, void 0, function* () {
    const LIMIT = 1000;
    let delegatees = [];
    let from = '';
    delegatees = yield SteemTxUtils.getData('condenser_api.get_vesting_delegations', [name, from, LIMIT]);
    return delegatees
        .filter((e) => parseFloat(e.vesting_shares + '') !== 0)
        .sort((a, b) => parseFloat(b.vesting_shares + '') - parseFloat(a.vesting_shares + ''));
});
const getPendingOutgoingUndelegation = (name) => __awaiter(void 0, void 0, void 0, function* () {
    const pendingDelegations = yield SteemTxUtils.getData('database_api.find_vesting_delegation_expirations', { account: name }, 'delegations');
    return pendingDelegations.map((pendingUndelegation) => {
        return {
            delegator: pendingUndelegation.delegator,
            expiration_date: pendingUndelegation.expiration,
            vesting_shares: parseInt(pendingUndelegation.vesting_shares.amount) / 1000000,
        };
    });
});
/* istanbul ignore next */
const delegateVestingShares = (delegator, delegatee, vestingShares, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return yield SteemTxUtils.sendOperation([getDelegationOperation(delegatee, delegator, vestingShares)], activeKey, false, options);
});
/* istanbul ignore next */
const getDelegationOperation = (delegatee, delegator, amount) => {
    return [
        'delegate_vesting_shares',
        {
            delegatee,
            delegator,
            vesting_shares: amount,
        },
    ];
};
/* istanbul ignore next */
const getDelegationTransaction = (delegatee, delegator, amount) => {
    return SteemTxUtils.createTransaction([
        DelegationUtils.getDelegationOperation(delegatee, delegator, amount),
    ]);
};
export const DelegationUtils = {
    getDelegationOperation,
    delegateVestingShares,
    getDelegators,
    getDelegatees,
    getPendingOutgoingUndelegation,
    getDelegationTransaction,
};
